import storyImagesObj from "./storyImagesObj";
import picnicAppliancesImagesObj from "./picnicAppliancesImagesObj";
import {
  dishIngredientsImagesObj,
  pizzaPrepImagesObj,
  pastaPrepImagesObj,
  burgerPrepImagesObj,
  smoothiePrepImagesObj,
} from "./ingredientsImagesObj";

export const allPicnicGameImages = {
  ...storyImagesObj,
  ...picnicAppliancesImagesObj,
  ...dishIngredientsImagesObj,
  ...pizzaPrepImagesObj,
  ...pastaPrepImagesObj,
  ...burgerPrepImagesObj,
  ...smoothiePrepImagesObj,
};
